<template>
    <div>
        <!-- <button class="btn btn-sm btn-warning px-3 ml-2">ใบปะหน้า</button> -->
        <b-dropdown-item v-for="(size , i) in labelSize" :key="i"
            :href="setTypeUrlLabel( size.value, false )" 
            target="_blank" >
            {{size.text}}
        </b-dropdown-item>
    </div>
</template>
<script>
import labelSize from '@/plugins/sizeLabel.js';
export default {
    name:'BtnLabel',
    props:{
        labelId: [String , Number]
    },
    data(){
        return {
            labelSize: labelSize
        }
    },
    methods:{
        setTypeUrlLabel( size , dropoff ){
            let url = `/label/${this.labelId}/${size}`
            if( dropoff ){
                url = url+'/dropoffShippop'
            }
            return url
        }
    }
}
</script>